module.exports = __webpack_public_path__ + "img/icon_social-media_facebook.1518409f.svg";